<template>
  <div>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headersValores"
          :items="itemValores"
          class="elevation-1 w-100 proposta h-100"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.investimentoTotal="{ item }">
            {{
              item.investimentoTotal &&
              item.investimentoTotal.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </template>

          <template v-slot:item.contrapartidaSebrae="{ item }">
            {{
              item.contrapartidaSebrae &&
              item.contrapartidaSebrae.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </template>

          <template v-slot:item.investimentoMunicipal="{ item }">
            {{
              item.investimentoMunicipal &&
              item.investimentoMunicipal.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })
            }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-if="ultrapassouValorTeto">
      <v-col>
        <div>
          <strong>
            O investimento total sem soluções extras ultrapassou o investimento
            do teto, valores sem subsídio são pagos integralmente pelo
            município.
          </strong>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { CombosEnum } from "./CombosEnum";

export default {
  name: "TabelaValoresProposta",
  props: {
    payload: { type: Object, required: true },
    faixa: { type: Object, default: null },
    combos: { type: Array, default: () => [] },
  },
  data() {
    return {
      headersValores: [
        { text: "", value: "combo", sortable: false },
        {
          text: "Investimento Total",
          value: "investimentoTotal",
          sortable: false,
        },
        {
          text: "Contrapartida Sebrae",
          value: "contrapartidaSebrae",
          sortable: false,
        },
        {
          text: "Investimento Municipal",
          value: "investimentoMunicipal",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    combosEssecialSolutionsId() {
      const comboEssencial =
        this.combos &&
        this.combos.length &&
        this.combos.find(
          (item) => (item.municipioPropostaCombosId = CombosEnum.essencial)
        );

      return (
        (comboEssencial &&
          comboEssencial.solucaoIds &&
          comboEssencial.solucaoIds.split(",")) ||
        []
      );
    },
    ultrapassouValorTeto() {
      return this.faixa && this.faixa.faixaTeto < this.getValorTotalSemExtra;
    },
    getExcedenteTeto() {
      return this.getValorTotalSemExtra - this.getValorTeto;
    },
    getValorEssencial() {
      return (this.faixa && this.faixa.valorFaixaEssencial) || 0;
    },
    getSomaSolucoes() {
      return this.payload.solucoesFaixasDTO
        .filter((item) => item.solucaoId || item.idSolucao)
        .reduce((partialSum, a) => {
          return partialSum + (a.precoFaixa || a.preco || 0);
        }, 0);
    },
    getValorTotalSemExtra() {
      return this.getSomaSolucoes + this.getValorEssencial;
    },
    getValorSebraeSemExtra() {
      return this.getSomaSolucoes + this.getValorEssencial;
    },
    getValorMunicipioSemExtra() {
      return this.getSomaSolucoes + this.getValorEssencial;
    },
    getValorTotal() {
      return (
        this.getSomaSolucoes +
        this.getValorEssencial +
        this.getValorSolucoesExtra.valorTotal
      );
    },

    faixaSubsidioPreium() {
      return (this.faixa && this.faixa.subsidioPremium) || 0;
    },
    faixaSubsidio() {
      return (this.faixa && this.faixa.faixaSubsidio) || 0;
    },

    getValorSolucoesExtra() {
      const extras = this.payload.solucoesFaixasDTO.filter(
        (item) => item.municipioPropostaSolucoesExtrasId
      );

      return {
        valorTotal: extras.reduce((partialSum, a) => {
          return partialSum + (a.preco || 0);
        }, 0),
        valorMunicipio: extras.reduce((partialSum, a) => {
          return partialSum + (a.valorMunicipio || 0);
        }, 0),
        valorSebrae: extras.reduce((partialSum, a) => {
          return partialSum + (a.valorSebrae || 0);
        }, 0),
      };
    },
    getValorTeto() {
      return (this.faixa && this.faixa.faixaTeto) || 0;
    },

    getValorSolucoesPorTeto() {
      //  o valor excedente do teto da faixa da proposta é entrado integralmente no investimento do municipio
      if (this.ultrapassouValorTeto) {
        return {
          valorSolucaoAteTeto:
            this.getValorTotalSemExtra -
            this.getValorEssencial -
            this.getExcedenteTeto,
          valorSolucaoAposTeto: this.getExcedenteTeto,
        };
      }

      return {
        valorSolucaoAteTeto: this.getSomaSolucoes,
        valorSolucaoAposTeto: 0,
      };
    },
    getValorContrapartidaSebraeSemExtra() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio = valorEssencial * (this.faixaSubsidio / 100);

      const valorComSubsidioPremium =
        this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
        (this.faixaSubsidioPreium / 100);

      return valorComSubsidio + valorComSubsidioPremium;
    },
    getValorInvestimentoMunicipalSemExtra() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio =
        valorEssencial * ((100 - this.faixaSubsidio) / 100);

      const valorComSubsidioPremium =
        this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
        ((100 - this.faixaSubsidioPreium) / 100);

      return (
        valorComSubsidio +
        valorComSubsidioPremium +
        this.getValorSolucoesPorTeto.valorSolucaoAposTeto
      );
    },
    getValorContrapartidaSebrae() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio = valorEssencial * (this.faixaSubsidio / 100);

      const valorComSubsidioPremium =
        this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
        (this.faixaSubsidioPreium / 100);

      return (
        valorComSubsidio +
        valorComSubsidioPremium +
        this.getValorSolucoesExtra.valorSebrae
      );
    },
    getValorInvestimentoMunicipal() {
      const valorEssencial =
        (this.faixa && this.faixa.valorFaixaEssencial) || 0;

      const valorComSubsidio =
        valorEssencial * ((100 - this.faixaSubsidio) / 100);

      const valorComSubsidioPremium =
        this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
        ((100 - this.faixaSubsidioPreium) / 100);

      return (
        valorComSubsidio +
        valorComSubsidioPremium +
        this.getValorSolucoesPorTeto.valorSolucaoAposTeto +
        this.getValorSolucoesExtra.valorMunicipio
      );
    },
    itemValores() {
      const contraPartidaSebrae = {
        essencial: this.getValorEssencial * (this.faixaSubsidio / 100),
        premium:
          this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
          (this.faixaSubsidioPreium / 100),
      };

      const investimentoMunicipipal = {
        essencial: this.getValorEssencial * ((100 - this.faixaSubsidio) / 100),
        premium:
          this.getValorSolucoesPorTeto.valorSolucaoAteTeto *
          ((100 - this.faixaSubsidioPreium) / 100),
      };

      let valores = [
        {
          combo: "Essencial",
          investimentoTotal: this.getValorEssencial,
          contrapartidaSebrae: contraPartidaSebrae.essencial,
          investimentoMunicipal: investimentoMunicipipal.essencial,
        },
        {
          combo: "Premium",
          investimentoTotal: this.getSomaSolucoes,
          contrapartidaSebrae: contraPartidaSebrae.premium,
          investimentoMunicipal: investimentoMunicipipal.premium,
        },
        {
          combo: "Teto",
          investimentoTotal: this.getValorTeto,
          contrapartidaSebrae: "-",
          investimentoMunicipal: "-",
        },
      ];

      if (this.ultrapassouValorTeto)
        valores.push({
          combo: "Valor sem Subsídio",
          investimentoTotal: this.getValorTotal - this.getValorTeto,
          contrapartidaSebrae: "-",
          investimentoMunicipal: this.getValorTotal - this.getValorTeto,
        });

      if (this.getValorSolucoesExtra.valorTotal > 0)
        valores.push(
          {
            combo: "Extra",
            investimentoTotal: this.getValorSolucoesExtra.valorTotal,
            contrapartidaSebrae: this.getValorSolucoesExtra.valorSebrae,
            investimentoMunicipal: this.getValorSolucoesExtra.valorMunicipio,
          },
          {
            combo: "Total sem Extras",
            investimentoTotal: this.getValorTotalSemExtra,
            contrapartidaSebrae: this.getValorContrapartidaSebraeSemExtra,
            investimentoMunicipal: this.getValorInvestimentoMunicipalSemExtra,
          }
        );

      valores = [
        ...valores,

        {
          combo: "Total",
          investimentoTotal: this.getValorTotal,
          contrapartidaSebrae: this.getValorContrapartidaSebrae,
          investimentoMunicipal: this.getValorInvestimentoMunicipal,
        },
      ];

      return valores;
    },
  },
};
</script>
